import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = '/nominas/contratacion';
export const baseURI2 = '/nominas/contratacion-vista-optimized';

/**
 * GET Tipos de Identificaciones
 * @returns {Promise<object[]>}
 */
export const getContrataciones = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Entrevista
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getContratacion = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Entrevista
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postContratacion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Entrevista
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchContratacion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Entrevista
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteContratacion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Entrevista
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarContratacion = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Tipos de Identificaciones
 * @returns {Promise<object[]>}
 */
export const getContratacionesVistaoptimizado = async (params) => {
  try {
    const response = await API.get(baseURI2, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};
